module.exports = __webpack_public_path__ + "img/tree-06-f-trunk.d562eb23.png";